import React from 'react'

import { useTranslation } from 'react-i18next'

import Button from '@components/shared/Button'
import { useDialogStore } from '@stores/dialog.store'

const PurchaseButton: React.FC = () => {
  const { t } = useTranslation()
  const openDialog = useDialogStore((s) => s.openDialog)

  return (
    <>
      <Button
        onClick={() => openDialog('purchase_title_dialog')}
        variant="primary"
        className="text-md py-1.5 px-3 flex flex-row items-center justify-center">
        {t('action.purchase')}
      </Button>
    </>
  )
}

export default PurchaseButton
